import React from 'react'
import {Helmet} from 'react-helmet'

import {enhancedGet} from '~/utils'

const SEOComponent = (props) => {
  const {
    title,
    keywords,
    description,
    thumbnail,
    url,
  } = props

  return (
    <Helmet>
      <title>{title}</title>

      <meta name='keywords' content={keywords} />

      <meta name='description' content={description} />

      <meta property='og:title' content={title} />

      <meta property='og:description' content={description} />

      <meta property='og:image' content={enhancedGet(thumbnail, 'url', '')} />

      <meta property='og:image:alt' content={enhancedGet(thumbnail, 'altText', `${title} thumbnail`)} />

      <meta property='og:image:type' content={enhancedGet(thumbnail, 'mimeType', '')} />

      <meta property='og:image:width' content={enhancedGet(thumbnail, 'mediaDetails.width', '')} />

      <meta property='og:image:height' content={enhancedGet(thumbnail, 'mediaDetails.height', '')} />

      <meta property='og:url' content={url} />
    </Helmet>
  )
}

export default SEOComponent
